function setCookie(v) {
    document.getElementById("__loginDC").value = v_dc.length > 0 ? v_dc : v;
    kasking.defineDC(v);
}
var kasking = {
    dc: '',
    defineDC: function(v) {
        return this.dc = v;
    }
};
function getQ(name) {
    url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function betterToFixed(num) {
    num = parseFloat(num);
	var str = num.toFixed(10);
	str = str.substring(0, str.length-8);
	return str;
};

function thousandSeperator(x,boo) {
	if (typeof(boo)==='undefined') boo=true;
	if(boo==true){
		return betterToFixed(x).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}else{
		return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}
}

function productMapping(tobeMapped){
	var finalProduct = 'GPI Slots';
	if(tobeMapped=='LIVECASINO'){
		finalProduct = 'GPI Live Casino';
	}else if(tobeMapped=='SPORTSBOOK'){
		finalProduct = 'GPI Sportsbook';
	}else if(tobeMapped=='PTSLOTS'){
		finalProduct = 'PT Slots';
	}else if(tobeMapped=='PTLIVECASINO'){
		finalProduct = 'PT Live Casino';
	}
	return finalProduct;
}
function maskLoginName(tobeMasked){
	var loginId = tobeMasked;
	var lastTwo = loginId.slice(-2);
	var loginLength = loginId.length;
	var maskLogin = loginId.substr(0,1);
	
	for (var i=0; i< loginLength; i++){
		maskLogin+='*';
	}
	maskLogin+=lastTwo;
	return maskLogin;
}
jQuery(function($) {
	
	 var API_ENDPOINT = '/ajax/';
        var $html = $('body'),
            $document = $(document),
            $window = $(window);
 
    $(function() {
		var cachecontrol = Math.floor(Math.random() * 99999);
        
		var flashvars = {
            //dc: v_dc
        };
		
        var attributes = {};
        var params = {
            menu: 'false',
            wmode: 'transparent',
            seamlessstabbing: false
        };
        swfobject.embedSWF(siteVariable.staticUrl + "/_scripts/dc.swf?nocache=" + cachecontrol, "divDCFlash", "10", "10", "9.0.0", "expressInstall.swf", flashvars, params, attributes);
	
        $('.prompt-login').fancybox();
        $('.promotion-modal').fancybox({
            title: null,
            type: 'inline',
            margin: 0,
            height: 'auto',
            maxHeight: $(window).height() * .8,
            beforeShow: function() {
                $('html,body').css('overflow', 'hidden');
                $('.fancybox-overlay').addClass('promo-modal-overlay')
            },
            afterClose: function() {
                $('html,body').css('overflow', 'auto');
            },
            tpl: {
                wrap: '<div class="fancybox-wrap promo-modal" tabIndex="-1"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>'
            }
        });
		$("[data-hide]").on("click", function(){
			$(this).closest("." + $(this).attr("data-hide")).hide();
			$(this).parent().parent().hide();
		});
        $('.close-modal').click(function(evt) {
            evt.preventDefault();
            $.fancybox.close()
        });

        function getTemplate(templateUrl) {
            return $.ajax({
                type: 'GET',
                url: templateUrl,
                async: false
            }).responseText;
        }
  
        $('.show-login').fancybox({
            margin: 0,
            padding: 5,
            title: null,
            type: 'inline',
            autoResize: true,
            beforeShow: function() {
                $('.sent-message,#forgotpassword-form,#login-change-password').hide();
                $('.sent-message,#forgotpassword-form,#login-change-password').find('input').val('');
                $('#loginform').show()
            },
            tpl: {
                wrap: '<div class="fancybox-wrap login-modal" tabIndex="-1"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>'
            }
        });
        $('.forgot-pw').click(function(evt) {
            evt.preventDefault();
            $('#loginform').hide();
            $('#forgotpassword-form').show();
            $window.resize();
        });
        $('#return-login').click(function(evt) {
            evt.preventDefault();
            $('#loginform').show();
            $('#forgotpassword-form').hide();
            $window.resize();
        });
				
		$('#forgotpassword-form').submit(function(e) {
            $window.resize();
            e.preventDefault()
        }).validate({
            forgotEmail: {
                required: true,
                email: true
            },
            onfocusout: function() {
                setTimeout(function() {
                    $window.resize()
                }, 500)
            },
            invalidHandler: function(form, validator) {
                $window.resize()
            },
            submitHandler: function(form) {
                $.ajax({
                    url: API_ENDPOINT + 'member_forgetpwd.ashx',
                    type: 'POST',
                    data: {
                        email: $('#forgotEmail').val(),
                        loginID: $('#forgotLogin').val()
                    },
                    success: function(d) {
                        if (d.err_code == '0') {
                            $('#forgotpassword-form').hide();
                            $('.sent-message').show();
                            $window.resize();
                        }
                    }
                });
            }
        });
		
		$("#login-change-password").submit(function(e) {
            e.preventDefault()
        }).validate({
            rules: {
                changeOldPassword: "required",
                changeNewPassword: {
                    required: true,
                    minlength: 8,
                    maxlength: 20,
                    regex: "^[a-zA-Z0-9]*$"
                },
                changeConfirmPassword: {
                    required: true,
                    equalTo: "#changeNewPassword"
                }
            },
            messages: {
                changeConfirmPassword: {
                    equalTo: localeMessage.validateSameValue
                }
            },
            submitHandler: function(form) {
				$('#login-change-password').find('button[type=submit]').attr('disabled', 'disabled');
                $.ajax({
                    url: API_ENDPOINT + 'member_changepwd.ashx',
                    data: {
                        oldpw: $.MD5($('#changeOldPassword').val()),
                        newpw: $.MD5($('#changeNewPassword').val())
                    },
                    success: function(d) {
						$('#login-change-password').find('button[type=submit]').removeAttr('disabled');
                        if (d.err_code == '0') {
                            $('#login-modal').find('input').val('');
                            $('#login-change-password').hide();
                            $('.changepw-message').show();
                        } else if(d.err_code == 'AFF-04'){
							$('#login-change-password .api-msg').addClass('error');
							$('#login-change-password .api-msg-inner').text(localeMessage.passwordMismatch);
						} else if(d.err_code == 'AFF-05'){
							$('#login-change-password .api-msg').addClass('error');
							$('#login-change-password .api-msg-inner').text(localeMessage.sameOld);
						}
						
						$('#login-change-password .api-msg').slideDown();
						setTimeout(function() {
							$('#login-change-password .api-msg').slideUp();
							$('#login-change-password .api-msg').removeClass('success error');
							$('#login-change-password .api-msg-inner').text('');
						}, 5000);
									
                    }
                });
                return false;
            }
        });
		
        $('.go-login').click(function(evt) {
            evt.preventDefault();
            $('.changepw-message').hide();
            $('#loginform').show();
            $window.resize();
        });
		
        $('.mobile-select').on('change blur',function(evt) {
            var optionSelected = $(this).find("option:selected").val();
            Cookies.set('lang', optionSelected);
            window.location.reload();
        })
        $('#captcha').realperson({
            hashName: 'captchaHash'
        });
	
		$('#contactCaptcha').realperson({
            hashName: 'captchaHash',
			position:'right'
        });
		
		$('#regCaptcha').realperson({
            hashName: 'captchaHash',
			position:'right'
        });
		$('.number-only').keypress(function(evt){
			var charCode = (evt.which) ? evt.which : evt.keyCode;
			if (charCode > 31 
			  && (charCode < 48 || charCode > 57))
				return false;

			return true;
		});
		$('.decimal-only').keypress(function(event) {
			var $this = $(this);
			if ((event.which != 46 || $this.val().indexOf('.') != -1) &&
			   ((event.which < 48 || event.which > 57) &&
			   (event.which != 0 && event.which != 8))) {
				   event.preventDefault();
			}

			var text = $(this).val();
			if ((event.which == 46) && (text.indexOf('.') == -1)) {
				setTimeout(function() {
					if ($this.val().substring($this.val().indexOf('.')).length > 3) {
						$this.val($this.val().substring(0, $this.val().indexOf('.') + 3));
					}
				}, 1);
			}

			if ((text.indexOf('.') != -1) &&
				(text.substring(text.indexOf('.')).length > 2) &&
				(event.which != 0 && event.which != 8) &&
				($(this)[0].selectionStart >= text.length - 2)) {
					event.preventDefault();
			}      
		});
		var clipboard = new Clipboard('.copy-me-btn');
		
        $('.logout').click(function(evt) {
            evt.preventDefault();
            $.ajax({
                url: API_ENDPOINT + 'member_logout.ashx',
                type: 'POST',
                success: function() {
                    location.reload(true);
                }
            });
        });
        
        $('.language li a').click(function(evt) {
            evt.preventDefault();
            var lang = $(this).attr('class');
			Cookies.set('lang', lang);
			window.location.reload();
        });
		
		$.validator.addMethod("regex", function(value, element, regexp) {
            var re = new RegExp(regexp);
            return this.optional(element) || re.test(value);
        }, function(params, el) {
            var type = $(el).attr('type');
            type = (type == 'password') ? 'password' : 'username';
            if (type == 'username') type = "login name";
            return "Your " + type + " can contain only letters & numbers.";
        });
		
        $.validator.addMethod('selectvalidate', function(value, el, param) {
            return value != '';
        }, "This field is required");
        $('button.navbar-toggle').click(function(e) {
            e.preventDefault()
        });

	    var websiteNumber = 0;	
		$('#registration').on('click', '.add', function(evt) {
		    evt.preventDefault();
			websiteNumber++;
			$(this).parent().hide();
			$('.add-website').append($('#website-input-template').clone().removeAttr('id').addClass('website-' + websiteNumber).show());
		});
		$('#registration').on('click', '.remove', function(evt) {
			evt.preventDefault();
			websiteNumber--;
			$(this).closest('.row').prev().find('.add-remove').show();
			$(this).closest('.row').remove();
		});
		var playerNumber = 0;	
		$('#player').on('click', '.add', function(evt) {
		    evt.preventDefault();
			playerNumber++;
			$(this).parent().hide();
			$('.add-player').append($('#player-input-template').clone().removeAttr('id').addClass('player-' + playerNumber).show());
		});
		$('#player').on('click', '.remove', function(evt) {
			evt.preventDefault();
			playerNumber--;
			$(this).closest('.row').prev().find('.add-remove').show();
			$(this).closest('.row').remove();
		});
		$('.search-media-result').on('click','.select-media .button', function(evt){
			evt.preventDefault();
			$(this).parents('.middle').slideUp()
			$(this).parents('.search-item').find('.edit-media').slideDown();
		});
		$('.search-media-result').on('click','.close-media', function(evt){
			evt.preventDefault();
			$(this).parents('.search-item').find('.select-media').slideDown()
			$(this).parents('.search-item').find('.edit-media').slideUp();
		});
		$('#search-link').find('#linkLanding').change(function(evt){
			evt.preventDefault();
			var selectedPage = $(this).val();
			$('#directlinks-tab').find('.layout-horizontal').hide();
			$('#directlinks-tab').find('.'+selectedPage).show();
		});
		
		$('#contact-form').submit(function(e) {
                e.preventDefault()
            }).validate({
                rules: {
                    contactLogin: {
                        required: true
                    },
                    contactName: {
                        required: true
                    },
                    contactEmail: {
                        required: true
                    },
                    contactMessage: {
                        required: true
                    },
					contactCaptcha: {
                        required: true
                    }
                },
				submitHandler:function(form){
					$('#contact-form').find('button[type=submit]').attr('disabled', 'disabled');
					setTimeout(function() {
						$.ajax({
							url: API_ENDPOINT + 'sendcontactmail.ashx',
							data: {
								LoginName: $('#contactLogin').val(),
								Name: $('#contactName').val(),
								Email: $('#contactEmail').val(),
								Subject: $('#contactSubject option:selected').text(),
								Message: $('#contactMessage').val(),
								Captcha:$('#contactCaptcha').val(),
								contactHash: $('.captcha-hash').val()
							},
							success: function(d) {
								if (d.err_code == 0) {
									$('#contact-form .api-msg').addClass('success');
									$('#contact-form .api-msg-inner').text(localeMessage.requestSuccess);
									$('#contact-form').find('.can-clear').val('');
								} else {
									$('#contact-form .api-msg').addClass('error');
									if(d.err_msg !=''){
								
										if (d.err_msg.indexOf('captcha') !== -1) {
											$('#contact-form .api-msg-inner').text(localeMessage.incorrectCaptcha);
											$window.scrollTop(0);
										} else {
											$('#contact-form .api-msg-inner').text(localeMessage.serverError);
											$window.scrollTop(0);
										}
									}
								}
								$('#contact-form').find('button[type=submit]').removeAttr('disabled');
								$('#contact-form .api-msg').slideDown();
								$('.realperson-regen').click();
								setTimeout(function() {
									$('#contact-form .api-msg').slideUp();
									$('#contact-form .api-msg').removeClass('success error');
									$('#contact-form .api-msg-inner').text('');
								}, 5000);
							}
						});
					},20);
				}
        });
		    
		if($('#registration').length>0){
			$.ajax({
				url: API_ENDPOINT + 'member_get_currency.ashx',
                type: 'GET',
				success:function(d){
					var remainCurrency = _(d.ds.dt).keyBy('code').omit(siteVariable.excludeCurrency.split(',')).value();
					//var remainCurrency = _(cur).keyBy('code').omit(siteVariable.excludeCurrency.split(',')).value();
				
					if(!_.isEmpty(remainCurrency)){
						var htmlOption = '';
						_.forEach(remainCurrency, function(value){
							htmlOption += '<option value="'+value.currencyId+'">';
							htmlOption += value.code+ ' - ' +value.name;
							htmlOption += '</option>';
						});
						
						$('#regCurrency').html(htmlOption);
					}
				}
			});
		}
        $('#registration').submit(function(e) {
            e.preventDefault()
        }).validate({
            rules: {
                regUsername: {
                    required: true,
                    minlength: 6,
                    maxlength: 20,
                    regex: "^[a-zA-Z0-9]*$"
                },
                regEmail: {
                    required: true,
                    email: true
                },
				regFirstName:'required',
				regLastName:'required',
				regAddress:'required',
				regCity:'required',
				regPostal:'required',
				regMobile:'required',
				regCommissionType:'required',
				regHow:{
					required: function() {
                        return $('input[name="regweb0"]').val()=='';
                    }
				},
				regCaptcha:'required'
            },
            messages: {
                regUsername: {
                    minlength: $.validator.format(localeMessage.validationMinLength)(6),
                    maxlength: $.validator.format(localeMessage.validationMaxLength)(20)
                },
                regEmail: {
                    email: localeMessage.validateEmail
                }
            },
			errorPlacement: function(err, el) {
                if ($(el).prop("id") == 'regCaptcha') {
					err.insertAfter(el.parent().find('.realperson-challenge'));
                } else {
                    err.insertAfter(el);
                }
            },
            submitHandler: function(form) {
				$('#registration').find('button[type=submit]').attr('disabled', 'disabled');
				var UrlString = '';
				$('.add-website input').each(function() {
					if ($(this).val() != '') {
						UrlString += $(this).val() + ';';
					}
				});
		
				setTimeout(function() {    
				$.ajax({
                    url: API_ENDPOINT + 'member_register.ashx',
                    type: 'POST',
                    data: {
                        username: escape($('#regUsername').val()),
                        firstname: escape($('#regFirstName').val()),
                        lastname: escape($('#regLastName').val()),
                        email: escape($('#regEmail').val()),
						address:escape($('#regAddress').val()),
						city:escape($('#regCity').val()),
						devcode: kasking.dc,
						postal:escape($('#regPostal').val()),
						mobile: escape($('#regMobile').val().replace(/\D/g, '')),
                        currencyid: $('#regCurrency').val(),
						currency: $('#regCurrency option:selected').text(),
						country: $('#regCountry').val(),
                        language: $('#regLanguage').val(),
						messenger:escape($('#regMessengerID').val()), 
						commission:escape($('#regCommissionType').val()), 
						referral: $('#regReferralID').val(), 
						how:escape($('#regHow').val()), 
						website:escape(UrlString),
                        useragent: siteVariable.useragent,
                        browser: $.browser.detected(),
                        accessurl: document.location.hostname,
                        ipaddress: siteVariable.ip,
                        ipcountry: siteVariable.country,
						captcha: $('#regCaptcha').val(),
						registerHash: $('.captcha-hash').val()
                    },
                    success: function(d) {
                        if (d.err_code == 0) {
                            $('.api-msg-inner').text(localeMessage.registerSuccess);
                            $('.api-msg').addClass('success').fadeIn();
                            $window.scrollTop(0);
							$('.can-clear').val('');
							window.location = '/';
                        } else {
                            $('.api-msg').addClass('error');
							if(d.err_msg !=''){
								
								if (d.err_msg.indexOf('EMAIL') !== -1) {
									$('.api-msg-inner').text(localeMessage.duplicateEmail);
									$window.scrollTop(0);
								} else if (d.err_msg.indexOf('contact') !== -1) {
									$('.api-msg-inner').text(localeMessage.invalidPhone);
									$window.scrollTop(0);
								} else if (d.err_msg.indexOf('captcha') !== -1) {
									$('.api-msg-inner').text(localeMessage.incorrectCaptcha);
									$window.scrollTop(0);
								} else if (d.err_msg.indexOf('LOGIN') !== -1) {
									$('.api-msg-inner').text(localeMessage.duplicateUser);
									$window.scrollTop(0);
								} else {
									$('.api-msg-inner').text(localeMessage.serverError);
									$window.scrollTop(0);
								}
							}
                        }
						$('#registration').find('button[type=submit]').removeAttr('disabled');
						$('.realperson-challenge').click();
                        $('.api-msg').slideDown();
                        setTimeout(function() {
                            $('.api-msg').slideUp().removeClass('error success');
                            $('.api-msg-inner').text('');
                        }, 5000);
                    }
                });
				},20);
			}
        });
		
		$('#account-detail').submit(function(e) {
            e.preventDefault()
        }).validate({
			rules:{
				detailAddress: 'required',
				detailCity: 'required',
				detailPostal: 'required'
			},
			submitHandler:function(form){
				$('#account-detail').find('button[type=submit]').attr('disabled', 'disabled');
				$.ajax({
					url: API_ENDPOINT + 'member_profileupdate.ashx',
                    type: 'POST',
                    data: {
						address:escape($('#detailAddress').val()),
						city:escape($('#detailCity').val()),
						postal:escape($('#detailPostal').val()),
						messenger:escape($('#detailMessengerID').val()),
						signinalert:($('#detailAlert').is(':checked'))?'1':'0'
					},
					success:function(d){
						if (d == '-9999') window.location = '';
						if (d.err_code == 0) {
                            $('#account-detail .api-msg').addClass('success');
                            $('#account-detail .api-msg-inner').text(localeMessage.requestSuccess);
                        } else {
							$('#account-detail .api-msg').addClass('error');
                            $('#account-detail .api-msg-inner').text(localeMessage.serverError);
                        }
                        $('#account-detail').find('button[type=submit]').removeAttr('disabled');
                        $('#account-detail .api-msg').slideDown();
						$window.scrollTop(0);
                        setTimeout(function() {
                            $('#account-detail .api-msg').slideUp();
                            $('#account-detail .api-msg').removeClass('success error');
							$('#account-detail .api-msg-inner').text('');
                        }, 5000);
					}
				});
			}
		});
        $('#loginform').on('keydown', 'input', function() {
            $('#loginform .api-msg').fadeOut();
            $('#loginform .api-msg-inner').text("");
        });
		
		$("#loginPassword, #changeOldPassword, #changeNewPassword, #changeConfirmPassword, #detailOldPassword, #detailPassword, #detailConfirmPassword").on('keyup blur',function() {
			$(this).val($(this).val().replace(/\s/g, ""));
		});
		
        $('#loginform').submit(function(e) {
            e.preventDefault()
        }).validate({
            rules: {
                loginEmail: 'required',
                loginPassword: 'required',
                captcha: {
                    required: function() {
                        return $('.captcha-group').is(':visible');
                    },
                    maxlength: 6,
                    minlength: 6
                }
            },
            onfocusout: function() {
                setTimeout(function() {
                    $window.resize()
                }, 500)
            },
            invalidHandler: function(form, validator) {
                $window.resize()
            },
            submitHandler: function(form) {
                setTimeout(function() {
                    $.ajax({
                        url: API_ENDPOINT + 'member_login.ashx',
                        type: 'POST',
                        data: {
                            username: $('#loginEmail').val(),
                            password: $.MD5($('#loginPassword').val()),
                            ipaddress: siteVariable.ip,
                            captcha: $('#captcha').val() || '',
                            captchaHash: $('#captcha-hash').val()
                        },
                        success: function(d) {
                            if (d.err_code == "0") {
                                window.location = window.location.protocol+'//'+window.location.host+'/Account';
                            } else {
                                if (d.err_msg.indexOf('INVALID') !== -1) {
                                    $('#loginform .api-msg-inner').text(localeMessage.loginWrongUsernamePassword);
                                } else if (d.err_msg.indexOf('captcha') !== -1) {
                                    $('#loginform .api-msg-inner').text(localeMessage.incorrectCaptcha);
                                } else if (d.err_msg.indexOf('block') !== -1) {
                                    $('#loginform .api-msg-inner').text(localeMessage.accountLocked);
                                } else {
                                    $('#loginform .api-msg-inner').text(localeMessage.serverError);
                                    $window.scrollTop(0);
                                }
                                if (d.err_code == 'AFFACCT-04') {
                                    $('#loginform').hide();
                                    $('#login-change-password').show();
                                    $capturePassword = $('#loginPassword').val()
                                    $('#changeOldPassword').val($capturePassword);
                                    $('#hashLoginId').val($('#loginEmail').val());
                                    $('#hashLogin').val('');
                                    $window.resize();
								}else {
                                    $('#loginform .api-msg').slideDown();
                                    if (d.captcha == '1') {
                                        $('#captcha').realperson('option', {});
                                        $('.captcha-group').removeClass('hide');
                                    }
                                }
                            }
                        },
                        error: function(xhr, status, err) {}
                    });
                }, 10);
                return false;
            }
        });
		if(getQ('refId')){
			Cookies.set('rafid',getQ('refId'));
		}
		if ($('#registration').length > 0) {
			$('#regReferralID').val(Cookies.get('rafid'));
            var countryList = '';
            var currencyList = '';
            $.ajax({
                type: 'GET',
                url: siteVariable.staticUrl + '/_json/country.json',
                success: function(r) {
                    $(r.countries.country).each(function(i, el) {
                        countryList += '<option value="' + el.CountryCode + '">' + el.Country + '</option>';
                    });
                    $('#regCountry').append(countryList);
                    $('#regCountry').val(siteVariable.country);
                },
                error: function(jqXHR, textStatus, errorThrown) {}
            });
            $('#regCountry').change(function() {
                $selectedCountry = $(this);
                $($dialing).each(function(i, el) {
                    if (el.code == $selectedCountry.val()) {
                        $('#regMobile').val(el.dial_code);
                    }
                })
            });
            var $dialing;
            $.ajax({
                type: 'GET',
                url: siteVariable.staticUrl + '/_json/dialing-code.json',
                success: function(r) {
                    $dialing = r;
                    $(r).each(function(i, el) {
                        if (el.code == siteVariable.country) {
                            $('#regMobile').val(el.dial_code);
                        }
                    });
                },
                error: function(jqXHR, textStatus, errorThrown) {}
            });
        }
    
		$('.toggle-change-password').click(function(evt) {
            evt.preventDefault();
            $('#change-password-cancel').fadeIn();
            $('.change-password-submit').addClass('is-show');
            $('#change-password').slideDown('fast', function() {
                $('.toggle-change-password').addClass('primary').removeClass('outline');
            });
        });
		$('#profile-tab').on('click','.toggle-change-password.primary',function(evt){
			evt.preventDefault();
			$("#change-password").submit();
		});
		$("#change-password").submit(function(evt){
				evt.preventDefault();
			}).validate({
				rules: {
					detailOldPassword: "required",
					detailPassword: {
						required: true,
						minlength: 8,
						maxlength: 20,
						regex: "^[a-zA-Z0-9]*$"
					},
					detailConfirmPassword: {
						required: true,
						equalTo: "#detailPassword"
					}
				},
				messages: {
					detailConfirmPassword: {
						equalTo: localeMessage.validateSameValue
					}
				},
				submitHandler: function(form){
					$('#change-password').find('button[type=submit]').attr('disabled', 'disabled');
					$.ajax({
						url: API_ENDPOINT + 'member_changepwd.ashx',
						data: {
							oldpw: $.MD5($('#detailOldPassword').val()),
							newpw: $.MD5($('#detailPassword').val())
						},
						success: function(d) {
							$('#change-password').find('button[type=submit]').attr('disabled', 'disabled');
							if (d == '-9999') window.location = '';
							if (d.err_code == '0') {
								$('.toggle-change-password').removeClass('primary').addClass('outline');
								$('#change-password-cancel').fadeOut();
								$('#change-password').slideUp('fast');
								$('#change-password').find('.can-clear').val('');
							} else if (d.err_code == 'AFF-04') {
								$('#change-password .pw-msg').addClass('error');
								$('#change-password .pw-msg-inner').text(localeMessage.passwordMismatch);
								$('#change-password .pw-msg').slideDown();
							} else if (d.err_code == 'AFF-05') {
								$('#change-password .pw-msg').addClass('error');
								$('#change-password .pw-msg-inner').text(localeMessage.sameOld);
								$('#change-password .pw-msg').slideDown();								
							}else {
								$('#change-password .pw-msg').addClass('error');
                                $('#change-password .pw-msg-inner').text(localeMessage.serverError);
								$('#change-password .pw-msg').slideDown();
                            }
							
							setTimeout(function() {
								$('#change-password .pw-msg').slideUp();
								$('#change-password .pw-msg').removeClass('success error');
								$('#change-password .pw-msg-inner').text('');
							}, 5000);
						}
					});
					
				}
		});
        $('#change-password-cancel').click(function(evt) {
            evt.preventDefault();
            $('.change-password-submit').removeClass('is-show');
            $('.toggle-change-password').removeClass('primary').addClass('outline');
            $('#change-password-cancel').fadeOut();
            $('#change-password').find('.can-clear').val('');
			$('#change-password').slideUp('fast');
            $("#change-password").clearValidation();
        });
		function toTitleCase(str){
			str = str.replace(/-/g, ' ');
			return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
		}
		
		var qrcode;
		$('#directlinks-tab').on('click','.generate-link-btn', function(evt){
			evt.preventDefault();
			var thisButton = $(this).parents('.form');
			var thisLinkId = $(this).parents('.layout-horizontal').attr('id');
			var thisItem = $(this).parents('.layout-horizontal');
			if(thisButton.find('.campaignID').val()==''){
				thisButton.find('.campaignID').val('Default');
			}
			if(thisButton.find('.customID').val()==''){
				thisButton.find('.customID').val('Default');
			}
			$.ajax({
				url:API_ENDPOINT + 'media_generate.ashx',
				data:{
					adtype:'dlink',
					description:escape(thisItem.find('.link-description').text()),
					mediaid:escape(thisLinkId),
					campid:thisButton.find('.campaignID').val(),
					custid:thisButton.find('.customID').val(),
				},
				success:function(d){
					if (d == '-9999') window.location = '';
					thisButton.find('.mt-2 input[type="text"]').val(d.redir+'&refId='+refCode)
					thisButton.find('.qrcode-wrapper').show();
					$('.qrcode').html('');
					if(typeof(qrcode)!='undefined'){
						qrcode.clear();
					}
					qrcode = new QRCode(document.getElementById('qrcode-'+thisLinkId), {
						text: d.redir+'&refId='+refCode,
						width: 140,
						height: 140,
						colorDark : "#000000",
						colorLight : "#ffffff",
						correctLevel : QRCode.CorrectLevel.H,
						id:'canvas-'+thisLinkId
					});
				},
				error:function(d){console.log(d);}
			});
		});
		var refCode = '';
		$('.search-media-result').on('click','.generate-btn',function(evt){
			evt.preventDefault();
			var thisForm = $(this).parents('form');
			var thisMedia = $(this).parents('.search-item');
			if(thisForm.find('.campaignID').val()==''){
				thisForm.find('.campaignID').val('Default');
			}
			if(thisForm.find('.customID').val()==''){
				thisForm.find('.customID').val('Default');
			}
			var camid = thisForm.find('.campaignID').val();
			var cusid = thisForm.find('.customID').val();
			if (thisForm.valid()) {
				$.ajax({
					url:API_ENDPOINT + 'media_generate.ashx',
					data:{
						adtype:'banner',
						mediaidx: thisMedia.find('.dashboard-title').attr('data-Idx'),
						campid: thisForm.find('.campaignID').val(),
						custid: thisForm.find('.customID').val(),
					},
					success:function(d){
						if (d == '-9999') window.location = '';
						var thisImg = thisMedia.find('.img-responsive').outerHTML();
						var thisTargetBlank = (thisForm.find('.open-new').is(':checked')==true)?' target="_blank"':'';
						buildLink = '<a href="'+d.redir+'&refId='+refCode+'"'+thisTargetBlank+'>';
						buildLink += thisImg;
						buildLink += '</a>';
						thisForm.find('.affiliate-link').val(buildLink);
					},
					error:function(d){console.log(d);}
				});
			}
		});	
		
		function getStatus(){
			$.ajax({
				url: API_ENDPOINT + 'member_profilelist.ashx',
                type: 'GET',
				success:function(d){
					if(d.err_code=='0'){
						if (d == '-9999') window.location = '';
						var payload = d.ds.dt[0];
						var userLang = '';
						refCode = payload.affId;
						$('#detailUsername').val(payload.loginId);
						$('#detailFirstName').val(payload.fname);
						$('#detailLastName').val(payload.lname);
						$('#detailEmail').val(payload.email);
						$('#detailAddress').val(payload.address);
						$('#detailCity').val(payload.city);
						$('#detailPostal').val(payload.postal);
						$('#detailMobile').val(payload.contact1);
						if(payload.currency=='IDR')payload.currency='USD';
						$('.get-balance').attr('data-currency', payload.currency);
						$('#detailCurrency').val(payload.currency);
						
						$('.get-balance').text($('.get-balance').attr('data-currency') + ' ' + thousandSeperator(payload.balance));
						$('.get-balance').attr('data-currencyid', payload.currencyId);
						
						$('#detailCountry').val(payload.countryName);
						$('#detailMessengerID').val(payload.messageID);
						$('#detailReferralID').val(payload.referralCode);
						var websiteArray = payload.websiteURL.split(";");
						_.each(websiteArray, function(website){
							if(website!=''){
								$('.user-website').append($('.website-input').clone().val(website).removeClass('website-input').show());
							}
						});
						
						$('#detailHow').val(payload.marketPromoText);
						if(payload.lang.indexOf('id') > -1){
							userLang = 'Bahasa';
						}else {
							userLang = 'English';
						}
						$('#detailLanguage').val(userLang);
						$('#detailCommissionType').val(toTitleCase(payload.commissionType).replace('_',' '));
						if(payload.signinAlert=='1'){
							$('#detailAlert').prop('checked','checked');
						}
						
						if(payload.submitWithdrawal==1||payload.fundTransToPlayer==1||payload.fundTransToSubAff==1||payload.purchaseClaimCode==1){
							$('#wallet-list').show();
							if(payload.submitWithdrawal==1) $('#withdraw-list').show();
							if(payload.fundTransToPlayer==1) $('#fundstransfer-list').show();
							if(payload.fundTransToSubAff==1) $('#subaffiliate-list').show();
							if(payload.purchaseClaimCode==1) $('#purchase-list').show();
						}
						
					}
				}
			});
		
			$.ajax({
				url: API_ENDPOINT + 'dashboard_get_register.ashx',
                type: 'GET',
				success:function(d){
					if (d == '-9999') window.location = '';
					if(d.err_code=='0'){
						if(d.ds.dt.length>0)$('.get-total').text(thousandSeperator(d.ds.dt[0].totalRegistered, false));
					}
				}
			});
			
				
			$.ajax({
				url: API_ENDPOINT + 'dashboard_get_today_new_player.ashx',
                type: 'GET',
				success:function(d){
					if (d == '-9999') window.location = '';
					if(d.err_code=='0'){
						var todayNewPlayer = 0;
						if(d.ds.dt.length>0){
							var todayNewPlayer = _.takeRight(d.ds.dt);
							$('.get-today-new-player').text(thousandSeperator(todayNewPlayer[0].totalNewPlayer, false));
						}
					}
				}
			});
			$.ajax({
				url: API_ENDPOINT + 'dashboard_get_today_new_sub.ashx',
                type: 'GET',
				success:function(d){
					if (d == '-9999') window.location = '';
					
					if(d.err_code=='0'){
						var todayNewSub = 0;
						if(d.ds.dt.length>0){
							var todayNewSub = _.takeRight(d.ds.dt);
							$('.get-today-sub-affiliate').text(thousandSeperator(todayNewSub[0].totalSubAff, false));
						}
					}
				}
			});
						
			$.ajax({
				url: API_ENDPOINT + 'dashboard_get_total_stake.ashx',
                type: 'GET',
				success:function(d){
					if (d == '-9999') window.location = '';
					if(d.err_code=='0'){
						var todayStake = 0;
						if(d.ds.dt.length>0){
							var todayStake = _.takeRight(d.ds.dt);
							$('.get-total-stake').text('USD '+thousandSeperator(parseFloat(todayStake[0].totalStake).toFixed(2), false));
						}
					}
				}
			});
			function nestedSum(){
				return 
			}
			$.ajax({
				url: API_ENDPOINT + 'dashboard_get_unique.ashx',
                type: 'GET',
				success:function(d){
					if (d == '-9999') window.location = '';
					if(d.err_code=='0'){
						var totalUnique = 0;
						var todayUnique = _.takeRight(d.ds.dt);
						totalUnique = _.reduce(_.split(todayUnique[0].totalClicks,'¶'),function(a,b){
							return parseInt(a)+parseInt(b);
						});
						$('.go-tracking .number').text(thousandSeperator(totalUnique,false));
					}
				}
			});
			
			$.ajax({
				url: API_ENDPOINT + 'dashboard_get_today_company_revenue.ashx',
                type: 'GET',
				success:function(d){
					if (d == '-9999') window.location = '';
					if(d.err_code=='0'){
						var totalRevenue = _.takeRight(d.ds.dt);
						$('.get-company-revenue').text('USD '+thousandSeperator(totalRevenue[0].netRevenue));			
					}
				}
			});
		}		

		if($('body').hasClass('account')){
			getStatus();
			$.ajax({
				url: API_ENDPOINT + 'dashboard_player_deposit_percent.ashx',
                type: 'GET',
				success:function(d){
					if (d == '-9999') window.location = '';
					if(d.err_code=='0'){
						if(d.ds.dt.length>0){
							$('.get-new-player .number').text(thousandSeperator(d.ds.dt[0].totalMem, false));
							var full = 100;
							var deduct = 100 - parseInt(d.ds.dt[0].percentage);
							var paper = Raphael("player-deposit-donut", 80, 80);
							var columns = [
							{ 
								value: parseInt(d.ds.dt[0].percentage), 
								color: '#EACD76' 
							},{ 
								value: deduct, 
								color: '#5D6562' 
							}];	
							new DonutChart(paper, columns, 35, 5, parseInt(d.ds.dt[0].percentage)+'%');
							$('#player-deposit-donut').find('tspan').attr('dy','5');
						}
					}
				}
			});
			
			$.ajax({
				url: API_ENDPOINT + 'dashboard_player_stake_percent.ashx',
                type: 'GET',
				success:function(d){
					if (d == '-9999') window.location = '';
					if(d.err_code=='0'){
						if(d.ds.dt.length>0){
							$('.get-sub-affiliate .number').text(thousandSeperator(d.ds.dt[0].totalMem, false));
							var full = 100;
							var deduct = 100 - parseInt(d.ds.dt[0].percentage);
							
							var paper = Raphael("player-stake-donut", 80, 80);
							var columns = [
							{ 
								value: parseInt(d.ds.dt[0].percentage), 
								color: '#EACD76' 
							},{ 
								value: deduct, 
								color: '#5D6562' 
							}];	
							new DonutChart(paper, columns, 35, 5, parseInt(d.ds.dt[0].percentage)+'%');
							$('#player-stake-donut').find('tspan').attr('dy','5');
						}
					}
				}
			});
		}
        
		
		function displayBanner(payload, el){
			var mediaTemplate = getTemplate(siteVariable.staticUrl + '/_templates/media-result.html?v='+siteVariable.version);
			payload.staticDomain = siteVariable.mediaUrl;
			payload.localeMessage = localeMessage;
			payload.static = siteVariable.staticUrl;
			var dotted = doT.template(mediaTemplate);
			el.find('.search-media-result .mt-2').html(dotted(payload));
			
			el.find('.edit-media form').each(function(){
				$(this).validate();
			});
			
			el.find('.edit-media form').find('.campaignID, .customID').each(function() {
				$(this).rules('add', {
					maxlength: 50
				});
			});	
		}
		if($('#search-media').length>0){
			var htmlDimension='', htmlProduct='', htmlProductId='';
			$.ajax({
				url: API_ENDPOINT + 'media_banner_searchdimension.ashx',
				success:function(d){
					if(d.length>0){
						htmlDimension+='<option value="">'+localeMessage.PleaseSelect+'</option>';
					}
					for (var i in d){
						if (d.hasOwnProperty(i)) {
							var splitwidth=d[i].split('x')[0];
							var splitheight=d[i].split('x')[1];
							htmlDimension+='<option value="'+d[i]+'" data-width="'+splitwidth+'" data-height="'+splitheight+'">'+d[i]+'</option>';
						}
					}
					$('#mediaDimension').html(htmlDimension);
					$('#mediaDimension').removeAttr('disabled');
				}
			});
			
			$.ajax({
				url: API_ENDPOINT + 'member_get_product.ashx',
				success:function(d){
					if(d.err_code==0){
						var productList = d.ds.dt;
						for (var i in productList){
							if (productList.hasOwnProperty(i)) {
								htmlProductId+='<option value="'+productList[i].productId+'">'+productList[i].productName+'</option>';
							}
						}
						$('#mediaProduct').append(htmlProductId);
						$('#claimProduct').append(htmlProductId);
					}
					
				}
			});
			
		}
		$('#search-media').submit(function(e){
			e.preventDefault();
		}).validate({
			submitHandler:function(form){
				$('#search-media').find('button[type=submit]').attr('disabled', 'disabled');
				$('#all-media-tab .search-media-result .mt-2').html(localeMessage.Searching);
				
				$.ajax({
					url: API_ENDPOINT + 'media_banner_search.ashx',
					data: {
						productid: $('#mediaProduct option:selected').val(),
						mediaid: $('#mediaID').val().trim(),
						lang: $('#mediaLanguage').val(),
						width: $('#mediaDimension option:selected').attr('data-width'),
						height: $('#mediaDimension option:selected').attr('data-height'),
						description: escape($('#mediaDescription').val().trim())
					},
					success: function(d) {
						if (d == '-9999') window.location = '';
						$('#search-media').find('button[type=submit]').removeAttr('disabled');
						if(d.err_code=='0'){
							$('#all-media-tab .search-media-result .mt-2').html(localeMessage.noRecord);
						}
						if(d.ds.dt.length>0){
							var payload={
								media:d.ds.dt,
								cat: 'all'
							}
							displayBanner(payload, $('#all-media-tab'));
						}
					}
				});
			}
		});
		if($('#new-media-tab').length>0){
			$('#new-media-tab .search-media-result .mt-2').html(localeMessage.Searching);
			$.ajax({
				url: API_ENDPOINT + 'media_banner_search.ashx',
				data: {
					mediatype:1
				},
				success: function(d) {
					if (d == '-9999') window.location = '';
					
					if(d.err_code=='0'){
						$('#new-media-tab .search-media-result .mt-2').html(localeMessage.noRecord);
					}
					if(d.ds.dt.length>0){
						var payload={
							media:d.ds.dt,
							cat: 'new'
						}
						displayBanner(payload, $('#new-media-tab'));
					}
					
				}
			});
		}
		if($('#exclusive-tab').length>0){
			$('#exclusive-tab .search-media-result .mt-2').html(localeMessage.Searching);
			$.ajax({
				url: API_ENDPOINT + 'media_banner_search.ashx',
				data: {
					mediatype:2
				},
				success: function(d) {
					if (d == '-9999') window.location = '';
					if(d.err_code=='0'){
						$('#exclusive-tab .search-media-result .mt-2').html(localeMessage.noRecord);
					}
					if(d.ds.dt.length>0){
						var payload={
							media:d.ds.dt,
							cat: 'exclusive'
						}
						displayBanner(payload, $('#exclusive-tab'));
					}
				}
			});
		}
		if($('#suggested-tab').length>0){
			$('#suggested-tab .search-media-result .mt-2').html(localeMessage.Searching);
			$.ajax({
				url: API_ENDPOINT + 'media_banner_search.ashx',
				data: {
					mediatype:3
				},
				success: function(d) {
					if (d == '-9999') window.location = '';
					if(d.err_code=='0'){
						$('#suggested-tab .search-media-result .mt-2').html(localeMessage.noRecord);
					}
					if(d.ds.dt.length>0){
						var payload={
							media:d.ds.dt,
							cat: 'suggested'
						}
						displayBanner(payload, $('#suggested-tab'));
					}
				}
			});
		}
		
		$('#performanceDate').daterangepicker({
			locale: {
			  format: 'DD-MMM-YYYY'
			},
			startDate:new Date()
		});
		$('#trackingDate').daterangepicker({
			locale: {
			  format: 'DD-MMM-YYYY'
			},
			startDate:moment().subtract(7,'d'),
			endDate:new Date()
		});
		$('#settlementDate').daterangepicker({
			locale: {
			  format: 'DD-MMM-YYYY'
			},
			startDate:new Date()
		});
		$('#performanceDisplayFormat').change(function(evt){
			evt.preventDefault();
		});
		$('#performance').submit(function(evt){
			evt.preventDefault();
		}).validate({
			submitHandler:function(form){
				$('.performance-result .mt-2').html(localeMessage.Searching);
				$('#performance').find('button[type=submit]').attr('disabled', 'disabled');
				performanceRange = $('#performanceDate').data('daterangepicker');
				
				$.ajax({
					url: API_ENDPOINT + 'performance.ashx',
					data:{
						breakdown: $('#performanceBreakDown').val(),
						datefrom: performanceRange.startDate.format('DD-MMM-YYYY')+'%2000:00%20AM',
						dateto: performanceRange.endDate.format('DD-MMM-YYYY')+'%2000:00%20AM',
						display: $('#performanceDisplayFormat').val()
					},
					success:function(d){
						$('#performance').find('button[type=submit]').removeAttr('disabled');
						
						var payload = {
							thousandSepFunc: thousandSeperator,
							maskName: maskLoginName,
							breakdown:d.ds.dt
							/*[
							{
								date:'01-06-2016',
								product:'playtech',
								totalstake:'2555.11',
								companyrevenue:'1023.10',
								uniqueclick:123,
								newplayer:12,
								subaffiliate:5,
								totalregister:888,
								playerwithdeposit:100,
								playerwithdepositpercent:10.40,
								playerwithstake:140,
								playerwithstakepercent:11.5,
							},{
								date:'01-06-2016',
								product:'netent',
								totalstake:'255.11',
								companyrevenue:'123.10',
								uniqueclick:12,
								newplayer:120,
								subaffiliate:9,
								totalregister:285,
								playerwithdeposit:300,
								playerwithdepositpercent:15.40,
								playerwithstake:150,
								playerwithstakepercent:51.5,
							},{
								date:'02-06-2016',
								product:'microgaming',
								totalstake:'200.51',
								companyrevenue:'13.10',
								uniqueclick:12,
								newplayer:120,
								subaffiliate:9,
								totalregister:285,
								playerwithdeposit:300,
								playerwithdepositpercent:15.40,
								playerwithstake:150,
								playerwithstakepercent:51.5,
							},{
								date:'02-06-2016',
								product:'gameplay',
								totalstake:'200.51',
								companyrevenue:'13.10',
								uniqueclick:12,
								newplayer:120,
								subaffiliate:9,
								totalregister:285,
								playerwithdeposit:300,
								playerwithdepositpercent:15.40,
								playerwithstake:150,
								playerwithstakepercent:51.5,
							}
							]*/
							,
							breakdownby:$('#performanceBreakDown').val(),
							display:$('#performanceDisplayFormat').val()
						};
						
						if(payload.breakdown.length==0){
							$('.performance-result .mt-2').html(localeMessage.noRecord);
						}else{
							var performanceTemplate = getTemplate(siteVariable.staticUrl + '/_templates/report-breakdown.html?v='+siteVariable.version);
							payload.localeMessage = localeMessage;
							/*
							payload.dateGroup = _(payload.breakdown)
							  .groupBy('date')
							  .map(function(b){
								  return b.reduce(sumUp,{
									date:b[0].date,
									totalstake:0, 
									companyrevenue:0,
									collection:{item:b, parent:b[0].date}})
								}).valueOf();
							*/
							var dotted = doT.template(performanceTemplate);
							$('.performance-result .mt-2').html(dotted(payload));
							$('.performance-result .tree-table').aCollapTable({ 
								startCollapsed: true,
								plusButton:'',
								minusButton:''
							});
							var pane = $('.performance-result .table-wrapper');
							pane.jScrollPane({autoReinitialise:true});
							var paneData = pane.data('jsp');
							
							$('.act-collapsed, .act-expanded').click(function(evt){
								evt.preventDefault();
								pane.height(pane.data('jsp').getContentPane().height());
								pane.find('.jspContainer').height(pane.data('jsp').getContentPane().height());
							});
						}
						
					}
				});
			}
		});
		$('.go-tracking').click(function(evt){
			evt.preventDefault();
			$('.nav-tabs a[href="#report-tab"]').tab('show');
			$('.nav-tabs a[href="#tracking-tab"]').tab('show');
			$('#trackingDate').daterangepicker({ startDate: new Date(), endDate: new Date() });
			$('#tracking').submit();
		});
		$('#tracking').submit(function(evt){
			evt.preventDefault();
		}).validate({
			submitHandler:function(form){
				$('#tracking').find('button[type=submit]').attr('disabled', 'disabled');
				$('.tracking-result .mt-2').html(localeMessage.Searching);
				trackingRange = $('#trackingDate').data('daterangepicker');
				$.ajax({
					url: API_ENDPOINT + 'media_banner_report.ashx',
					data: {
						DateFrom:trackingRange.startDate.format('DD-MMM-YYYY'),
						DateTo:trackingRange.endDate.format('DD-MMM-YYYY'),
						campId:$('#trackingCampaign').val().trim(),
						cusId:$('#trackingCustomID').val().trim(),
						mediaId:$('#trackingMediaID').val().trim(),
						description:$('#trackingMediaDescription').val().trim(),
					},
					success: function(d) {
						$('#tracking').find('button[type=submit]').removeAttr('disabled');
						if (d == '-9999') window.location = '';
						if(d.err_code=='0'){
							var payload = {
								trackingresult:d.ds.dt
							}
							if(payload.trackingresult.length==0){
								$('.tracking-result .mt-2').html(localeMessage.noRecord);
							}else{
								var trackingTemplate = getTemplate(siteVariable.staticUrl + '/_templates/report-tracking.html?v='+siteVariable.version);
								payload.localeMessage = localeMessage;
								
								payload.adGroup = {
									group:_.map(
									_.groupBy(payload.trackingresult, 'campId'),
									function(values) {
										return {
											name:values[0].campId,
											item: _.map(
											  _.groupBy(values,'custId')
											,function(nested){
											  return{
												child:nested,
												counting: _.reduce(_.map(nested, 'counting'), sum, 0),
												id:nested[0].custId
											  }
											}),
											counting: _.reduce(_.map(values, 'counting'), sum, 0)
										};
									}),
									total: _.reduce(_.map(payload.trackingresult, 'counting'), sum, 0)
								};
								var dotted = doT.template(trackingTemplate);
								$('.tracking-result .mt-2').html(dotted(payload));
								
								$('.tracking-result .thousand-separate').each(function(){
									rawInt = $(this).text();
									$(this).text(thousandSeperator(rawInt,false));
								});
								$('.tracking-result .tree-table').aCollapTable({ 
									startCollapsed: true,
									addColumn:false,
									plusButton:'',
									minusButton:''
								});
							}
							
						}
					}
				});
			}
		});
		
		
		$('#commissionsettlement').submit(function(evt){
			evt.preventDefault();
		}).validate({
			submitHandler:function(form){
				$('#commissionsettlement').find('button[type=submit]').attr('disabled', 'disabled');
				$('.commissionsettlement-result .mt-2').html(localeMessage.Searching);
				commRange = $('#settlementDate').data('daterangepicker');
				$.ajax({
					url: API_ENDPOINT + 'commissionsettlement.ashx',
					data: {
						datefrom:commRange.startDate.format('YYYY-MM-DD'),
						dateto:commRange.endDate.format('YYYY-MM-DD')
					},
					success: function(d) {
						$('#commissionsettlement').find('button[type=submit]').removeAttr('disabled');
						if (d == '-9999') window.location = '';
						if(d.err_code=='0'){
							if(d.ds.dt.length==0) {
								$('.commissionsettlement-result .mt-2').html(localeMessage.noRecord).addClass('text-center');
							}else{
								/*[
								{
									TransactionDate:'11-11-2016',
									uap:'5',
									commissionType:'fixed',
									grossRevenue: '10000',
									qualified: '10000',
									paymentfee:'50',
									rewards:'100',
									loyalty:'200',
									bonus:'123',
									netrevenue:'987',
									subaffiliatecomm:'777',
									lastsettlement:'741',
									commamt:'951',
									balancerollover:'753',
									payoutcomm:'654',
									revenueData:[
										{product:'GPI Slots', login:'1***ih',revenue:'213456'},
										{product:'GPI Slots', login:'3***iv',revenue:'74102'},
										{product:'GPI Slots', login:'n***ha',revenue:'9898'},
									]
								},{
									TransactionDate:'10-10-2016',
									uap:'5',
									commissionType:'cpa',
									grossRevenue: '10000',
									qualified: '10000',
									paymentfee:'555',
									rewards:'666',
									loyalty:'777',
									bonus:'888',
									netrevenue:'999',
									subaffiliatecomm:'000',
									lastsettlement:'753',
									commamt:'951',
									balancerollover:'654',
									payoutcomm:'852',
									revenueData:[
										{product:'GPI Slots', login:'1***ih',revenue:'213456'},
										{product:'GPI Slots', login:'3***iv',revenue:'74102'},
										{product:'GPI Slots', login:'n***ha',revenue:'9898'}
									]
								}
								]*/
								
								var payload = {
									thousandSepFunc: thousandSeperator,
									settlement:d.ds.dt
								}
								var settlementTemplate = getTemplate(siteVariable.staticUrl + '/_templates/report-commissionsettlement.html?v='+siteVariable.version);
								payload.localeMessage = localeMessage;
					
								var dotted = doT.template(settlementTemplate);
								$('.commissionsettlement-result .mt-2').html(dotted(payload));
								
								var settlementPane = $('#commissionsettlement-tab .table-wrapper').jScrollPane({autoReinitialise:true});
								setTimeout(function(){
									paneHeight = settlementPane.data('jsp').getContentPane().find('table').actual( 'outerHeight', {includeMargin:true})+100;
									settlementPane.height(paneHeight);
									settlementPane.find('.jspContainer').height(paneHeight);
								},20);
								
								$('.fetch-this').each(function(i,el){
									var cycleDate = $(this).text();
									writeCycleDate(cycleDate.split('T')[0], el);
								});
							}
						}
					}
				});
			}
		});
		function writeCycleDate(date, ele){
			$.ajax({
				type:'GET',
				async:false,
				url: API_ENDPOINT + 'lastsettlementbalance.ashx',
				data:{
					reportingDate:date
				},
				success:function(d){
					$(ele).html(thousandSeperator(d.balance));
				}
			})
		}
		$('#commissionsettlement-tab').on('click','.view-revenue', function(evt){
			evt.preventDefault();
			var thisRevenue = $(this);
			
			var popOver = thisRevenue.popover({
				placement : 'top',
				container:'body',
				html:true,
				content:'Loading'
			});
			popOver.popover('show');
			if(popOver.data('bs.popover')) {
			}else{
				//popOver.popover('show');
			}
			var popOverData = thisRevenue.attr('bs.popover') 
			var commType = popOver.attr('data-type');
			var thissettlementperiod = popOver.attr('data-settlementperiod');
			var thisreportingdate = popOver.attr('data-reporting');
			if(commType=='cpa'){
				$.ajax({
					url: API_ENDPOINT + 'cpabreakdown.ashx',
					data: {
						reportingdate:thisreportingdate
					},
					success:function(d){
						var returnContent = localeMessage.noRecord;
						if(d.ds.dt.length>0) {
							if(popOver.data('bs.popover')) {
								returnContent = '<table>';
								returnContent += '<tr>';
								returnContent += '<th>'+localeMessage.PlayerLoginName+'</th>';
								returnContent += '<th>'+localeMessage.Currency+'</th>';
								returnContent += '<th>'+localeMessage.Deposit+'</th>';
								returnContent += '</tr>';
								_.each(d.ds.dt, function(data){
									var secretName = maskLoginName(data.loginId);
									returnContent += '<tr>';
									returnContent += '<td class="text-center">'+secretName+'</td>';
									returnContent += '<td class="text-center">'+data.currency+'</td>';
									returnContent += '<td class="text-right">'+thousandSeperator(data.totalAdp)+'</td>';
									returnContent += '</tr>';
								});
								returnContent += '</table>';
								popOver.data('bs.popover').options.content = returnContent;
								
							}	
						}else{
							returnContent = '<table>';
							returnContent += '<tr>';
							returnContent += '<th class="text-center">'+localeMessage.noRecord+'</th>';
							returnContent += '</tr>';
							returnContent += '</table>';
							popOver.data('bs.popover').options.content = returnContent;
						}
						popOver.popover('show');
					}
				});
			}else{
				$.ajax({
					url: API_ENDPOINT + 'member_get_gross_revenue.ashx',
					data: {
						settlementperiod:thissettlementperiod,
						reportingdate:thisreportingdate
					},
					success:function(d){
						var returnContent = localeMessage.noRecord;
						if(d.ds.dt.length>0) {
							if(popOver.data('bs.popover')) {
								returnContent = '<table>';
								returnContent += '<tr>';
								returnContent += '<th>'+localeMessage.Product+'</th>';
								returnContent += '<th>'+localeMessage.PlayerLoginName+'</th>';
								returnContent += '<th>'+localeMessage.GrossRevenue+'</th>';
								returnContent += '</tr>';
								_.each(d.ds.dt, function(data){
									var secretName = maskLoginName(data.loginId);
									var mappedProduct = productMapping(data.gameProvider);
									returnContent += '<tr>';
									returnContent += '<td class="text-center">'+ mappedProduct +'</td>';
									returnContent += '<td class="text-center">'+secretName+'</td>';
									returnContent += '<td class="text-right">'+thousandSeperator(data.baseWinLose)+'</td>';
									returnContent += '</tr>';
								});
								returnContent += '</table>';
								popOver.data('bs.popover').options.content = returnContent;
								popOver.popover('show');
							}	
						}else{
							returnContent = '<table>';
							returnContent += '<tr>';
							returnContent += '<th class="text-center">'+localeMessage.noRecord+'</th>';
							returnContent += '</tr>';
							returnContent += '</table>';
							popOver.data('bs.popover').options.content = returnContent;
						}
						popOver.popover('show');
					}
				});
			}
			
			/*
			$('[data-toggle="popover"]').popover({
				placement : 'top',
				container:'body',
				html:true,
				selector: '[rel="popover"]',
				content:function(){
					return 'asd';
				}
			});
			*/
		});
		
		$('body').on('click', function (e) {
			$('[data-toggle=popover]').each(function () {
				if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
					$(this).popover('hide');
				}
			});
		});
		function loadCashTrackerPage(num){
			$.ajax({
				url: API_ENDPOINT + 'cashtracker.ashx',
				data:{page:cashTrackerCurrentPage},
				success:function(d){
					
			
					if(d.ds.dt.length==0) {
						$('#cashtracker-tab .mt-2').html(localeMessage.noRecord).addClass('text-center');
					}else{
						cashTrackerTotalPage = d.ds.dt[0].NoOfPages;
						var payload = {
							history:d.ds.dt,total:cashTrackerTotalPage, 
							current:cashTrackerCurrentPage,
							thousandSepFunc: thousandSeperator
						};
						var cashTrackerTemplate = getTemplate(siteVariable.staticUrl + '/_templates/report-cashtracker.html?v='+siteVariable.version);
						var dotted = doT.template(cashTrackerTemplate);
						payload.localeMessage = localeMessage;
					
						if(num==1){
							$('#cashtracker-tab .mt-2').html(localeMessage.Searching);
							$('#cashtracker-tab .mt-2').html(dotted(payload));
							cashTrackerPane = $('#cashtracker-tab .table-wrapper').jScrollPane({
								autoReinitialise: true
							});
							
						}else{
							$('#cashtracker-tab .mt-2 table').append(dotted(payload));
						}
						$('#cashtracker-tab .mt-2 .positive').text(function(){
							return $(this).text().replace('-','');
						})
						setTimeout(function(){
							paneHeight = cashTrackerPane.data('jsp').getContentPane().find('table').actual( 'outerHeight', { includeMargin : true });
							cashTrackerPane.height(paneHeight);
							cashTrackerPane.find('.jspContainer').height(paneHeight);
						},150);
						
						if(cashTrackerCurrentPage==cashTrackerTotalPage)$('#cashtracker-tab').find('.load-more').hide();
						
					}
					
				}
			});
		}
		var cashTrackerTotalPage = 1;
		var cashTrackerCurrentPage = 1;
		var cashTrackerPane;
		if($('#cashtracker-tab').length>0){
			loadCashTrackerPage(cashTrackerCurrentPage);
		}
		$('#cashtracker-tab').on('click','.load-more', function(evt){
			evt.preventDefault();
			cashTrackerCurrentPage++;
			loadCashTrackerPage(cashTrackerCurrentPage);
		});
		
		var sum = function(t, n) { return t + n; };
		
		function sumUp(p, c) {
			return _.extend(p, {
				totalstake:(parseFloat(p.totalstake) + parseFloat(c.totalstake)).toFixed(2), 
				companyrevenue:(parseFloat(p.companyrevenue) + parseFloat(c.companyrevenue)).toFixed(2)
			});
		};
		
		
		$('.copy-me-btn').tooltip({
			trigger:'manual'
		});
		clipboard.on('success', function(e) {
			var clicked = e.trigger.id;
			e.clearSelection();
			$('#'+clicked).tooltip('show');
			
			setTimeout(function() {
				$('#'+clicked).tooltip('hide');
			}, 1000);
			return false;
		});
		$('.tab-content').on('click','.copy-me-btn', function(evt){
			evt.preventDefault();
		});
		$('#withdraw').submit(function(evt){
			evt.preventDefault();
		}).validate({
			rules:{
				withdrawAmount:{
					required: true
				},
				withdrawBankName:'required',
				withdrawBankBranch:'required',
				withdrawBankAddress:'required',
				withdrawAccountNumber:'required',
				withdrawBankAccountName:'required'
			},
			submitHandler:function(form){
				$('#withdraw').find('button[type=submit]').attr('disabled', 'disabled');
				$.ajax({
					url: API_ENDPOINT + 'member_wallet_withdraw.ashx',
					data: {
						amount:$('#withdrawAmount').val(),
						currency: $('.get-balance').attr('data-currency'),
						currencyid:$('.get-balance').attr('data-currencyid'),
						accessurl: document.location.hostname,
						bankname: $('#withdrawBankName').val(),
						acctname:$('#withdrawBankAccountName').val(),
						acctnum:$('#withdrawAccountNumber').val(),
						bankbranch:$('#withdrawBankBranch').val(),
						bankaddress:$('#withdrawBankAddress').val()
					},
					success: function(d) {
						if (d == '-9999') window.location = '';
						if (d.err_code == 0) {
							$('#withdraw .api-msg').addClass('success');
							$('#withdraw .api-msg-inner').text(localeMessage.requestSuccess);
							getStatus();
							$('#withdraw').find('.can-clear').val('');
							cashTrackerCurrentPage=1;
							loadCashTrackerPage(cashTrackerCurrentPage);
						}else if(d.err_code=='AFF-11'&&  d.err_msg.indexOf('insufficient')> -1 ) {
							$('#withdraw .api-msg').addClass('error');
							$('#withdraw .api-msg-inner').text(localeMessage.insufficientBalance);
						}else if(d.err_code=='AFF-12' &&  d.err_msg.indexOf('LESS')> -1 ) {
							$('#withdraw .api-msg').addClass('error');
							$('#withdraw .api-msg-inner').text(localeMessage.minimumAmount);
						}else if(d.err_code=='AFF-17' ) {
							$('#withdraw .api-msg').addClass('error');
							$('#withdraw .api-msg-inner').text(localeMessage.noPermission);
						}else {
							$('#withdraw .api-msg').addClass('error');
							if(d.err_msg !=''){
								$('#withdraw .api-msg-inner').text(localeMessage.serverError);
							}			
						}
						$('#withdraw').find('button[type=submit]').removeAttr('disabled');
						$('#withdraw .api-msg').slideDown();
						setTimeout(function() {
							$('#withdraw .api-msg').slideUp();
							$('#withdraw .api-msg').removeClass('success error');
							$('#withdraw .api-msg-inner').text('');
						}, 5000);		
					}
				})
			}
		});
		
		if($('#player').length>0){
			
			$.ajax({
				url: API_ENDPOINT + 'member_search_player.ashx',
				
				success: function(d) {
					if (d == '-9999') window.location = '';
					var $playerList ='';
					if(d.ds.dt.length>0){
						var payload = d.ds.dt;
						_.each(payload, function(data){
							$playerList+='<option value="'+data.memId+'">'+data.loginId+'</option>';
						});
						$('#playerID').append($playerList);
						$("#playerID").chosen({
							width:'100%',
							no_result_text:localeMessage.NoResultsMatch
						});
						
					}
				}
			});
		}
		
		$('#player').submit(function(e){
			e.preventDefault();
			$("#player").data('validator').settings.ignore = "";
		}).validate({ 
			rules:{
				playerAmount:{
					required: true
				}
			},
			errorPlacement(err, el){
				if(el.attr('id')=='playerID'){
					err.insertAfter($('.chosen-container'));
				}else{
					err.insertAfter(el);
				}
			},
			submitHandler:function(form){
				$('#player').find('button[type=submit]').attr('disabled', 'disabled');
				
				$.ajax({
					url: API_ENDPOINT + 'member_transfer_player.ashx',
					data: {
						amount:$('#playerAmount').val(),
						currency: $('.get-balance').attr('data-currency'),
						currencyid:$('.get-balance').attr('data-currencyid'),
						accessurl: document.location.hostname,
						memId:$('#playerID').val()
					},
					success: function(d) {
						if (d == '-9999') window.location = '';
						if (d.err_code == 0) {
							$('#player .api-msg').addClass('success');
							$('#player .api-msg-inner').text(localeMessage.requestSuccess);
							getStatus();
							cashTrackerCurrentPage=1;
							loadCashTrackerPage(cashTrackerCurrentPage);
							$('#player').find('.can-clear').val('');
						}else if(d.err_code=='AFF-17' ) {
							$('#player .api-msg').addClass('error');
							$('#player .api-msg-inner').text(localeMessage.noPermission);
						}else{
							$('#player .api-msg').addClass('error');
							$('#player .api-msg-inner').text(localeMessage.serverError);
						}
						$('#player').find('button[type=submit]').removeAttr('disabled');
						$('#player .api-msg').slideDown();
						setTimeout(function() {
							$('#player .api-msg').slideUp();
							$('#player .api-msg').removeClass('success error');
							$('#player .api-msg-inner').text('');
						}, 5000);		
					}
				});
			}
		});
		
		
		Array.prototype.flattenObj = function (inputArray, ischild) {
			ischild = ischild || false;
			var i = 0, len = inputArray.length;
			for (i = 0; i < len; i++) {
				this.push(inputArray[i]);

				if (inputArray[i].subaff && typeof inputArray[i].subaff === typeof []) {
					this.flattenObj(inputArray[i].subaff, true);
				}
			}
			if(ischild === false){return this;}
		};
		
		if($('#subAffiliateAff').length>0){
			$.ajax({
				url: API_ENDPOINT + 'member_search_sub.ashx',
				
				success: function(d) {
					if (d == '-9999') window.location = '';
					var $subafftList ='';
					if(d.ds.dt.subaff.length>0){
						var payload = d.ds.dt.subaff;
						var flattenedArray = [].flattenObj(payload);
						_.each(flattenedArray, function(data){
							$subafftList+='<option value="'+data.affId+'">'+data.loginId+'</option>';
						});
						$('#subAffiliateAff').append($subafftList);
					}
				}
			});
		}
		
		$('#subaffiliate').submit(function(e){
			e.preventDefault();
		}).validate({
			rules:{
				subAffiliateAmount:{
					required: true
				},
				subAffiliate:'required'
			},
			submitHandler:function(form){
				$('#subaffiliate').find('button[type=submit]').attr('disabled', 'disabled');
				$.ajax({
					url: API_ENDPOINT + 'member_transfer_subaffiliate.ashx',
					data: {
						amount:$('#subAffiliateAmount').val(),
						currency: $('.get-balance').attr('data-currency'),
						currencyid:$('.get-balance').attr('data-currencyid'),
						subaffiliate:$('#subAffiliateAff').val()
					},
					success: function(d) {
						if (d == '-9999') window.location = '';
						if (d.err_code == 0) {
							$('#subaffiliate .api-msg').addClass('success');
							$('#subaffiliate .api-msg-inner').text(localeMessage.requestSuccess);
							cashTrackerCurrentPage=1;
							loadCashTrackerPage(cashTrackerCurrentPage);
							getStatus();
							$('#subaffiliate').find('.can-clear').val('');
						}else if(d.err_code=='AFF-17' ) {
							$('#subaffiliate .api-msg').addClass('error');
							$('#subaffiliate .api-msg-inner').text(localeMessage.noPermission);
						}else{
							$('#subaffiliate .api-msg').addClass('error');
							$('#subaffiliate .api-msg-inner').text(localeMessage.serverError);
						}
						$('#subaffiliate').find('button[type=submit]').removeAttr('disabled');
						$('#subaffiliate .api-msg').slideDown();
						setTimeout(function() {
							$('#subaffiliate .api-msg').slideUp();
							$('#subaffiliate .api-msg').removeClass('success error');
							$('#subaffiliate .api-msg-inner').text('');
						}, 5000);		
					}
				});
			}
		});
		
		$('#claimEffectiveDateFromAndTo').daterangepicker({
			locale: {
			  format: 'DD-MMM-YYYY'
			},
			startDate:new Date()
		});
		$('#claimRegisterDateFromAndTo').daterangepicker({
			locale: {
			  format: 'DD-MMM-YYYY'
			},
			startDate:new Date()
		});
		
		$('#purchase').submit(function(e){
			e.preventDefault();
		}).validate({
			rules:{
				claimAmount:'required',
				claimProduct:'required',
				claimRolloverFactor:'required',
				claimPromo:'required',
				claimEffectiveDateFromAndTo:'required',
				claimRegisterDateFromAndTo:'required',
			},
			submitHandler:function(form){
				$('#purchase').find('button[type=submit]').attr('disabled', 'disabled');
				effDate = $('#claimEffectiveDateFromAndTo').data('daterangepicker');
				regDate = $('#claimRegisterDateFromAndTo').data('daterangepicker');
				$.ajax({
					url: API_ENDPOINT + 'member_purchase_claim.ashx',
					data: {
						amount:$('#claimAmount').val(),
						currency: $('.get-balance').attr('data-currency'),
						currencyid:$('.get-balance').attr('data-currencyid'),
						product:$('#claimProduct').val(),
						rollover:$('#claimRolloverFactor').val(),
						promo:$('#claimPromo').val(),
						effectiveDateTimeFrom:effDate.startDate.format('DD-MMM-YYYY'),
						effectiveDateTimeTo:effDate.endDate.format('DD-MMM-YYYY'),
						registerDateTimeFrom:regDate.startDate.format('DD-MMM-YYYY'),
						registerDateTimeTo:regDate.endDate.format('DD-MMM-YYYY'),
						accessurl: document.location.hostname
					},
					success: function(d) {
						if (d == '-9999') window.location = '';
						if (d.err_code == 0) {
							$('#purchase .api-msg').addClass('success');
							$('#purchase .api-msg-inner').text(localeMessage.requestSuccess);
							cashTrackerCurrentPage=1;
							loadCashTrackerPage(cashTrackerCurrentPage);
							getStatus();
							$('#purchase').find('.can-clear').val('');
						}else if(d.err_code=='AFF-17' ) {
							$('#purchase .api-msg').addClass('error');
							$('#purchase .api-msg-inner').text(localeMessage.noPermission);
						}else{
							$('#purchase .api-msg').addClass('error');
							$('#purchase .api-msg-inner').text(localeMessage.serverError);
						}
						$('#purchase').find('button[type=submit]').removeAttr('disabled');
						$('#purchase .api-msg').slideDown();
						setTimeout(function() {
							$('#purchase .api-msg').slideUp();
							$('#purchase .api-msg').removeClass('success error');
							$('#purchase .api-msg-inner').text('');
						}, 5000);		
					}
				});
			}
		});
	
	
	
		$('.prompt-idle').fancybox();
		var isIdle = 0;
		$(document).idle({
			onIdle: function() {
				
				if (isIdle != 1&&($('body').hasClass('logged-in'))&&(window.isMobile()==false)) {
					isIdle = 1;
					$('.prompt-idle').click();
				}
			},
			idle: 3600000
		});
	});
	function downloadCanvas(link, canvasId, filename) {
		link.href = document.getElementById(canvasId).toDataURL();
		link.download = filename;
	}
	$( '.save-qrcode').on('click',function(evt){
		var qrcodeId = $(this).parents('.layout-horizontal').attr('id');
		downloadCanvas($(this)[0], 'canvas-'+qrcodeId, qrcodeId+'-qrcode.png');
	});
	jQuery.validator.addMethod("notEqualToGroup", function(value, element, options) {
        var elems = $(element).parents('form').find(options[0]);
        var valueToCompare = value;
        var matchesFound = 0;
        jQuery.each(elems, function() {
            thisVal = $(this).val();
            if (thisVal == valueToCompare) {
                matchesFound++;
            }
        });
        if (this.optional(element) || matchesFound <= 1) {
            return true;
        } else {}
    }, localeMessage.duplicatedEmail);
	
	
	

});
jQuery.extend(jQuery.validator.messages, {
    required: localeMessage.validationRequired,
    email: localeMessage.validateEmail,
    url: "Please enter a valid URL.",
    date: "Please enter a valid date.",
    dateISO: "Please enter a valid date (ISO).",
    number: "Please enter a valid number.",
    digits: "Please enter only digits.",
    equalTo: localeMessage.validateSameValue
});
$(function() {
    var triggerBookmark = $(".js-bookmark");
    triggerBookmark.click(function() {
        if (window.sidebar && window.sidebar.addPanel) {
            window.sidebar.addPanel(document.title, window.location.href, '');
        } else if (window.external && ('AddFavorite' in window.external)) {
            window.external.AddFavorite(location.href, document.title);
        } else if (window.opera && window.print || window.sidebar && !(window.sidebar instanceof Node)) {
            triggerBookmark.attr('rel', 'sidebar').attr('title', document.title);
            return true;
        } else {
            alert('You can add this page to your bookmarks by pressing ' + (navigator.userAgent.toLowerCase().indexOf('mac') != -1 ? 'Command/Cmd' : 'CTRL') + ' + D on your keyboard.');
        }
        return false;
    });
});
window.isMobile = function() {
    var check = false;
    (function(a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od|ad)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
};
jQuery.browser = {
    msie: /*@cc_on!@*/ false || !! document.documentMode,
    chrome: !! window.chrome && !! window.chrome.webstore,
    safari: Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0,
    webkit: navigator.userAgent.toLowerCase().search("webkit") >= 0,
    firefox: typeof InstallTrigger !== 'undefined',
    opera: ( !! window.opr && !! opr.addons) || !! window.opera || navigator.userAgent.indexOf(' OPR/') >= 0,
    ieedge: !this.msie && !! window.StyleMedia,
    detected: function() {
        if ( /*@cc_on!@*/ false || !! document.documentMode) {
            return 'MSIE';
        } else if ( !! window.chrome && !! window.chrome.webstore) {
            return 'CHROME';
        } else if (Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0) {
            return 'SAFARI';
        } else if (typeof InstallTrigger !== 'undefined') {
            return 'FIREFOX';
        } else if (( !! window.opr && !! opr.addons) || !! window.opera || navigator.userAgent.indexOf(' OPR/') >= 0) {
            return 'OPERA';
        } else if (!this.msie && !! window.StyleMedia) {
            return 'IEEDGE';
        } else if (navigator.userAgent.toLowerCase().search("webkit") >= 0) {
            return 'WEBKIT';
        } else if ((this.chrome || this.opera) && !! window.CSS) {
            return 'BLINK';
        }
    }
}
$.fn.clearValidation = function() {
    var v = $(this).validate();
    $('[name]', this).each(function() {
        v.successList.push(this);
        v.showErrors();
    });
	$(this).find('label.error').remove();
    v.resetForm();
    v.reset();
}; 
$.fn.outerHTML = function(s) {
    return s
        ? this.before(s).remove()
        : jQuery("<p>").append(this.eq(0).clone().removeAttr('class')).html();
};